import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> { }

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={ type }
        className={ cn(
          "flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 active:bg-nfPurple-950 transition-colors read-only:bg-slate-950/20 read-only:focus:ring-0 read-only:focus:ring-transparent border-nfPurple-600 bg-slate-950 ring-offset-slate-950 placeholder:text-slate-400 focus-visible:ring-nfBlue-300",
          className
        ) }
        ref={ ref }
        autoComplete="off"
        { ...props }
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
